/**
 * A SPARQL query.
 */
export class SparqlQuery {
    /**
     * The namespace prefixes used by the query.
     */
    prefixes;
    /**
     * The WHERE portion of the query.
     */
    where;
}
/**
 * A SELECT SPARQL query.
 */
export class SparqlSelectQuery extends SparqlQuery {
    /**
     * The array of variables returned by the query.
     */
    select;
}
/**
 * A CONSTRUCT SPARQL query.
 */
export class SparqlConstructQuery extends SparqlQuery {
    /**
     * The CONSTRUCT pattern.
     */
    construct;
}
export function sparqlQueryIsSelect(query) {
    return query.select !== undefined;
}
export function sparqlQueryIsConstruct(query) {
    return query.construct !== undefined;
}
/**
 * Represents a graph pattern.
 */
export class SparqlPattern {
    /**
     * The array of elements inside the pattern.
     */
    elements;
}
/**
 * Represents an element inside a graph pattern.
 */
export class SparqlElement {
}
/**
 * Represents a triple match in a pattern.
 */
export class SparqlTriple extends SparqlElement {
    /**
     * The subject node of the triple.
     */
    subject;
    /**
     * The predicate node of the triple.
     */
    predicate;
    /**
     * The object node of the triple.
     */
    object;
}
/**
 * Represents an OPTIONAL pattern.
 */
export class SparqlOptionalPattern extends SparqlElement {
    /**
     * The nested optional pattern.
     */
    optionalPattern;
}
/**
 * Represents a UNION pattern.
 */
export class SparqlUnionPattern extends SparqlElement {
    /**
     * The patterns of which the union is formed.
     */
    unionPatterns;
}
export function sparqlElementIsTriple(element) {
    return element.subject !== undefined;
}
export function sparqlElementIsOptional(element) {
    return element.optionalPattern !== undefined;
}
export function sparqlElementIsUnion(element) {
    return element.unionPatterns !== undefined;
}
/**
 * Represents an RDF node in SPARQL.
 */
export class SparqlNode {
}
/**
 * Represents a URI node.
 */
export class SparqlUriNode {
    /**
     * The URI value of the node.
     */
    uri;
}
/**
 * Represents a URI node using a namespace prefix.
 */
export class SparqlQNameNode {
    /**
     * The {@link QName} value of the node.
     */
    qname;
}
/**
 * Represents a variable node.
 */
export class SparqlVariableNode {
    /**
     * The name of the variable.
     */
    variableName;
}
export function sparqlNodeIsUri(node) {
    return node.uri !== undefined;
}
export function sparqlNodeIsQName(node) {
    return node.qname !== undefined;
}
export function sparqlNodeIsVariable(node) {
    return node.variableName !== undefined;
}
//# sourceMappingURL=sparql-model.js.map